import React from 'react'
import Box from '@mui/material/Box'
import ProjectCard from './ProjectCard'
import { useConfig } from '../../hooks/useConfig'
import { Project } from '../../types/types'

const ProjectGrid: React.FC = () => {
    const { config } = useConfig()

    if (!config || !config.projectsData) {
        return null
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-evenly',
                gap: '20px',
            }}
        >
            {config.projectsData.map((project: Project, index: number) => (
                <ProjectCard key={index} {...project} />
            ))}
        </Box>
    )
}

export default ProjectGrid
